<template>
  <div class="table-skeleton">
    <!-- Header shimmer -->
    <div class="skeleton-header">
      <div v-for="i in cols" :key="`h${i}`" class="skeleton-cell">
        <div class="shimmer shimmer-header"></div>
      </div>
    </div>
    <!-- Row shimmers -->
    <div
      v-for="row in rows"
      :key="`r${row}`"
      class="skeleton-row"
      :class="{ 'skeleton-row--even': row % 2 === 0 }"
    >
      <div v-for="col in cols" :key="`c${col}`" class="skeleton-cell">
        <div
          class="shimmer"
          :class="col === 1 ? 'shimmer-sm' : col === cols ? 'shimmer-action' : 'shimmer-md'"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableSkeleton",
  props: {
    rows: { type: Number, default: 8 },
    cols: { type: Number, default: 6 },
  },
};
</script>

<style scoped>
.table-skeleton {
  width: 100%;
  overflow: hidden;
}

.skeleton-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  gap: 16px;
}

.skeleton-row {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
  gap: 16px;
}

.skeleton-row--even {
  background: #fafafa;
}

.skeleton-cell {
  flex: 1;
  min-width: 0;
}

.skeleton-cell:first-child {
  flex: 0 0 48px;
}

.skeleton-cell:last-child {
  flex: 0 0 100px;
}

/* Base shimmer */
.shimmer {
  border-radius: 6px;
  background: linear-gradient(
    90deg,
    #f1f5f9 0%,
    #e2e8f0 40%,
    #f1f5f9 80%
  );
  background-size: 400% 100%;
  animation: shimmer-slide 1.4s ease infinite;
}

.shimmer-header {
  height: 12px;
  width: 70%;
  border-radius: 4px;
}

.shimmer-sm {
  height: 14px;
  width: 40px;
}

.shimmer-md {
  height: 14px;
  width: 80%;
}

.shimmer-action {
  height: 28px;
  width: 80px;
  border-radius: 8px;
}

/* Stagger animation per row */
.skeleton-row:nth-child(1) .shimmer { animation-delay: 0s; }
.skeleton-row:nth-child(2) .shimmer { animation-delay: 0.07s; }
.skeleton-row:nth-child(3) .shimmer { animation-delay: 0.14s; }
.skeleton-row:nth-child(4) .shimmer { animation-delay: 0.21s; }
.skeleton-row:nth-child(5) .shimmer { animation-delay: 0.28s; }
.skeleton-row:nth-child(6) .shimmer { animation-delay: 0.35s; }
.skeleton-row:nth-child(7) .shimmer { animation-delay: 0.42s; }
.skeleton-row:nth-child(8) .shimmer { animation-delay: 0.49s; }

@keyframes shimmer-slide {
  0%   { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}
</style>
